import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const TeamDetailsSection = ({ member }) => {
  // helper render link (nếu url bắt đầu bằng "http" thì dùng <a>, nếu không thì dùng <Link>)
  const renderLink = (url, children) => {
    if (!url) return null;
    return url.startsWith("http") ? (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        {children}
      </a>
    ) : (
      <Link to={url}>{children}</Link>
    );
  };

  return (
    <section className="team-details-section fix section-padding">
      <div className="container">
        <div className="team-details-wrapper">
          <div className="row g-4">
            {/* Hình ảnh */}
            <div className="col-lg-6">
              <div className="team-details-image">
                <img
                  src={member.detailsImage}
                  alt={member.name}
                  loading="lazy"
                />
              </div>
            </div>

            {/* Nội dung chi tiết */}
            <div className="col-lg-6">
              <div className="details-content">
                <h2>{member.name}</h2>
                <span>{member.position}</span>

                {/* Giới thiệu */}
                <div className="team-about-info">
                  <h3 className="mb-2">Giới thiệu:</h3>
                  <p>{member.about}</p>
                </div>

                {/* Thông tin chi tiết */}
                <div className="details-info">
                  <h6 className="team-details-info">
                    Địa chỉ: <span>{member.location}</span>
                  </h6>
                  <h6 className="team-details-info">
                    Vai trò: <span>{member.position}</span>
                  </h6>
                  <h6 className="team-details-info">
                    Email:{" "}
                    <a
                      href={`mailto:${member.email}`}
                      className="link"
                    >
                      {member.email}
                    </a>
                  </h6>
                  <h6 className="team-details-info">
                    Năm sinh: <span>{member.birthYear}</span>
                  </h6>
                  <h6 className="team-details-info">
                    Trình độ: <span>{member.qualification}</span>
                  </h6>
                  <h6 className="team-details-info">
                    Giới tính: <span>{member.gender}</span>
                  </h6>
                </div>

                {/* Dự án / Portfolio */}
                {member.portfolio?.length > 0 && (
                  <div className="portfolio-tag">
                    <h3>Dự án:</h3>
                    <ul>
                      {member.portfolio.map((p, i) => (
                        <li key={i}>{renderLink(p.url, p.name)}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Mạng xã hội */}
                <div className="social-icon d-flex align-items-center">
                  <h3>Kết nối:</h3>
                  {renderLink(member.socials.facebook, <FaFacebookF />)}
                  {renderLink(member.socials.twitter, <FaTwitter />)}
                  {renderLink(member.socials.instagram, <FaInstagram />)}
                  {renderLink(member.socials.linkedin, <FaLinkedinIn />)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamDetailsSection;
